/* src/app/intro/tipps/tipps.component.scss */
/*# sourceMappingURL=tipps.component.css.map */
